import * as React from 'react';

import { Scrollable } from '@rematter/ui-web';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { InventoryItemRecord } from '~/modules/trade/types/load';

export type CatalyticItemTab = 'vehicle' | 'notes' | 'photos' | 'files';

export type CatalyticConverterDetailViewProps = {
  effectiveColorScheme: 'light' | 'dark';
  activeTab: CatalyticItemTab;
  /** The item being edited */
  item?: InventoryItemRecord | null;
  /** The line item (row) ID for fetching/saving item-specific data */
  lineItemId?: string | null;
};

export const CatalyticConverterDetailView = ({
  effectiveColorScheme,
  activeTab,
  item: _item,
  lineItemId: _lineItemId,
}: CatalyticConverterDetailViewProps) => {
  const t = useTranslations();

  const tabLabels: Record<CatalyticItemTab, string> = {
    vehicle: t.inventoryItemsModal.catalyticTabs.vehicle,
    notes: t.inventoryItemsModal.catalyticTabs.notes,
    photos: t.inventoryItemsModal.catalyticTabs.photos,
    files: t.inventoryItemsModal.catalyticTabs.files,
  };

  return (
    <Scrollable
      themeMode={effectiveColorScheme}
      className="@CatalyticConverterDetailView"
    >
      <div className="flex h-full flex-col items-center justify-center gap-4 py-12">
        <span className="text-lg font-medium text-neutral/40">
          {tabLabels[activeTab]}
        </span>
        <span className="text-neutral/30">
          {t.inventoryItemsModal.comingSoon}
        </span>
      </div>
    </Scrollable>
  );
};
